import { DatasourceResource, DeprecatedApiService } from '@mode/legacy/data-access-model-js';
import { ApiTypes } from '@mode/shared/contract-common';

export class ConnectionPermissionsListService {
  static $inject = ['ApiService'];

  constructor(private apiService: DeprecatedApiService) {}

  public destroyEntitlement(entitlement: ApiTypes.ModeResource): angular.IPromise<any> {
    return this.apiService.destroy(entitlement, {});
  }

  public createGroupEntitlement(datasource: DatasourceResource, groupToken: string, action): angular.IPromise<any> {
    return this.apiService.create(datasource, 'permissions', {
      'permission.resource_type': 'data_source',
      'permission.resource_token': datasource.token,
      'permission.action': action,
      'permission.accessor_type': 'UserGroup',
      'permission.accessor_token': groupToken,
    });
  }

  public updateEntitlement(entitlement: ApiTypes.ModeResource, action: string): angular.IPromise<any> {
    return this.apiService.edit(entitlement, {
      'permission.action': action,
    });
  }
}
